import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgClose({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.587l7.293-7.294a1 1 0 111.414 1.414l-7.292 7.294 7.292 7.292a1 1 0 01-1.414 1.414L12 13.415l-7.294 7.296a1 1 0 11-1.414-1.414L10.587 12 3.293 4.707a1 1 0 011.414-1.414l7.294 7.294z"
        fill={color}
      />
    </svg>
  )
}

export default SvgClose
